import { MenuItem } from "@/model/Application/MenuItem";

export interface IDictionary<T> {
	[index: string]: T;
}

export class UserCompanyLink {
	Local: boolean;
	BaseUrl: string;
	Url: string;
}

export class UserCompanyConfiguration {
	Configuration: IDictionary<string>;
	Links: IDictionary<UserCompanyLink>;
	Menu: Array<MenuItem>;
}

export class UserCompanyConfigurationKeys {
	static readonly ForceComments = "forse_comments";
	static readonly ClassicMode = "classic_mode";
	static readonly HideShift = "hide_shift";
}

export const GetUserCompanyConfigurationToggle = (
	key: string,
	configuration: UserCompanyConfiguration | null,
): boolean => {
	return !configuration
		? true
		: Boolean(Number(configuration?.Configuration[key]));
};
